<template>
  <div class="pdf-container">
    <object data="/documents/USB Club Terms of Service 10.04.23.pdf" type="application/pdf" style="min-height:100vh;width:100%"></object>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  props: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
  },
  methods: {
  },
};
</script>

<style>
.pdf-container {
  position: absolute;
  height: 100%;
  width: 100%;
}
</style>


